import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import Loader from "components/Loader/Loader.js";

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Switch>
      {routes.map((route, key) => {
        const Component = route.component;

        return (
          <Route
            key={key}
            path={route.layout + route.path}
            exact={route.exact}
            render={(props) => <Component {...props} />}
          />
        );
      })}
    </Switch>
  </Suspense>
);

var routes = [
  {
    exact: true,
    path: "/",
    name: "Home Page",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/Documents")), 
    layout: "",
  },{
    exact: true,
    path: "/documents/:layouts?",
    name: "Last News",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/Documents")), 
    layout: "",
  },{
    exact: true,
    path: "/document/:publicId?",
    name: "Preview Document",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/Documents/Preview")), 
    layout: "",
  },{
    exact: true,
    path: "/search/:issuer?",
    name: "Search",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/Search")), 
    layout: "",
  },{
    exact: true,
    path: "/old-documents/:issuer?",
    name: "Last News",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/DocumentsOld")), 
    layout: "",
  },{
    exact: true,
    path: "/confidentiality/:language?",
    name: "Confidentiality",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/Confidentiality")), 
    layout: "",
  },{
    exact: true,
    path: "/about/:language?",
    name: "About",
    icon: "tim-icons icon-bank",
    component: lazy(() => import("./views/About")), 
    layout: "",
  },
];
export default routes;
